export default __webpack_public_path__ + "static/media/more-icon.06213368.svg";